export default __webpack_public_path__ + "images/b2a104ccb7b88dec354957a200d1be45-valentines_header_image_desktop.webp";